import type { PermissionKey } from '@shared/permissions'

/** Where to send someone after sign-in. */
const LANDING_ORDER: ReadonlyArray<{ path: string; anyOf: PermissionKey[] }> = [
  { path: '/', anyOf: ['overview.view'] },
  { path: '/chatbot', anyOf: ['leads.view', 'chats.view'] },
  { path: '/users', anyOf: ['users.view'] },
  { path: '/settings', anyOf: ['settings.view'] },
  { path: '/audit', anyOf: ['audit.view'] },
]

/** The first permitted route, or `null` when there is none. */
export function resolveLandingRoute(permissions: ReadonlySet<string>): string | null {
  for (const entry of LANDING_ORDER) {
    if (entry.anyOf.some((p) => permissions.has(p))) return entry.path
  }
  return null
}
